import Vue from 'vue';
import Router from 'vue-router';
import nProgress from 'nprogress';

// Inventory Module Routes
import Authentication from '../../Authentication/route';
import SettingsRoutes from '../../Pretailer/Modules/Settings/routes/setting-routes';
import InventoryRoutes from '../../Pretailer/Modules/Inventory/route';
import OutletRoutes from '../../Pretailer/Modules/Outlet/outlet-routes';
import CustomerRoutes from '../../Pretailer/Modules/Customer/customer-routes';
import OrderRoutes from '../../Pretailer/Modules/Order/order-routes';
import PaymentRoutes from '../../Pretailer/Modules/Payment/payment-routes';
import SecurityRoutes from '../../Pretailer/Modules/Security/routes/security-routes';
import LoyaltyRoutes from '../../Pretailer/Modules/Loyalty/loyalty-routes';
import CouponRoutes from '../../Pretailer/Modules/Coupons/coupon-routes';

// Dashboard Module Route
import ChartDashBoardRoute from '../../Dashboard/route';

// AI Module Route
import Customer360 from '../../Analytics/Modules/Customer360/customer_routes';
import MerchantFiles from '../../Analytics/Modules/MerchantFiles/merchant_files_routes';
import Recommendations from '../../Analytics/Modules/Recommendations/recommendation_routes';
import SalesPrediction from '../../Analytics/Modules/SalesPrediction/sales_prediction_routes';
import GeoAnalysis from '../../Analytics/Modules/GeospatialAnalysis/geo_routes';

Vue.use(Router);

const routes = [
  ...Authentication,
  {
    path: '/',
    redirect: '/dashboard/overview',
    component: () => import(/* webpackChunkName: "Base" */'../views/Base'),
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        {
          name: 'Home',
          path: '/',
        },
      ],
    },
    children: [
      ...SettingsRoutes,
      ...InventoryRoutes,
      ...OutletRoutes,
      ...CustomerRoutes,
      ...OrderRoutes,
      ...PaymentRoutes,
      ...ChartDashBoardRoute,
      ...SecurityRoutes,
      ...Customer360,
      ...MerchantFiles,
      ...Recommendations,
      ...SalesPrediction,
      ...GeoAnalysis,
      ...LoyaltyRoutes,
      ...CouponRoutes,
    ],
  },
];

const router = new Router({
  mode: 'history',
  routes,
});

router.beforeResolve((to, from, next) => {
  if (to.name) {
    nProgress.start();
  }
  next();
});

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
  nProgress.done();
});

router.beforeEach((to, from, next) => {
  // Make sure the menu overlay is off
  const isLoggedIn = localStorage.getItem('jwt_token');
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!isLoggedIn) {
      next({
        path: '/auth/login',
        query: { redirect: to.fullPath },
      });
    }
  } else if (isLoggedIn) {
    next({
      path: '/dashboard/overview',
      query: { redirect: to.fullPath },
    });
  }

  next();
});

export default router;
